__turbopack_context__.v({
  "body": "-MXRWG_body",
  "card": "-MXRWG_card",
  "cta": "-MXRWG_cta",
  "outer": "-MXRWG_outer",
  "stage": "-MXRWG_stage",
  "textStack": "-MXRWG_textStack",
  "title": "-MXRWG_title",
});
